<div class="sap__selector d-flex">
  <ng-select
    id="sapSearch"
    class="custom-select__sap"
    [items]="sapSearchResults"
    bindValue="id"
    placeholder="Search saved SAP"
    [searchable]="true"
    [loading]="sapSearchLoading"
    [typeahead]="sapSearchSubject"
    (change)="onSelectPaymentMethod($event)"
    [(ngModel)]="selectedCostCenterId"
    [clearable]="false"
  >
    <ng-template ng-label-tmp let-item="item">
      {{ item.label }}
    </ng-template>
    <ng-template ng-header-tmp> Saved SAP Information </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <span>{{ item.label }}</span>
    </ng-template>
  </ng-select>
  <button class="btn btn-link font-5" (click)="addSap()" title="Add SAP">
    Add SAP <i class="fas fa-plus"></i>
  </button>
</div>
